import React, { useState } from "react";
import { useDispatch } from "react-redux";
import "swiper/swiper-bundle.css";
import { addToCart } from "../../../store/cart.slice";
import { BsStar, BsStarFill } from "react-icons/bs";
import { FaHeart, FaShareAlt, FaShoppingCart } from "react-icons/fa";
import { toast } from "react-toastify";
import "../../../styles/imgZoom.css";

const ProductDetail = ({ product }) => {
  const dispatch = useDispatch();
  const [quantity, setQuantity] = useState(1);
  const [activeImage, setActiveImage] = useState(0);

  const handleAddToCart = () => {
    console.log("quandtity before adding", quantity);
    toast.success("Product added", {
      autoClose: 1000,
      position: "bottom-right",
    });
    dispatch(
      addToCart({
        id: product.id,
        image: product.image,
        name: product.name,
        description: product.description,
        price: product.price,
        quantity: quantity,
      })
    );
  };

  const increaseQuantity = () => {
    setQuantity((prev) => prev + 1);
  };

  const decreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity((prev) => prev - 1);
    }
  };

  const [backgroundPosition, setBackgroundPosition] = useState("0% 0%");

  const handleMouseEnter = (event) => {
    console.log("mouse enter");
    const mousePosition = {
      x: event.clientX,
      y: event.clientY,
    };
    console.log(mousePosition);

    const { left, top, width, height } = event.target.getBoundingClientRect();
    const x = ((mousePosition.x-left) / width) * 100;
    const y = ((mousePosition.y-top) / height) * 100;
    setBackgroundPosition(`${x}% ${y}%`);
  };

  const handleMouseLeave = () => {
    setBackgroundPosition("0% 0%");
  };

  return (
    <main className="container  my-8 " role="main">
      {/* <div className="  "> */}
      {/* content-space-t-1 content-space-t-sm-2 */}

      <div className="row g-4 ">
        <div className="col-md-7 ">
          <div
            className="aspect-square"
            id="image-zoom"
            style={{
              '--url': `url(${product.image[activeImage].url})`,
              '--bg-position': backgroundPosition,
            }}
            onMouseMove={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <img
              alt="Product"
              className="rounded-lg p-2"
              height="500px"
              src={product.image[activeImage].url}
              style={{
                objectFit: "center",
                // aspectRatio: "600/500",
              }}
              width="600px"
            />
          </div>

          <div className="row g-2 gap-2 mt-2">
            {product.image.map((image, i) => (
              <div
                key={i}
                className={`col-3 border rounded-2 d-flex align-items-center justify-content-center ${
                  i === activeImage ? "border-primary" : ""
                }`}
                onClick={() => setActiveImage(i)}
              >
                <img
                  alt={`Product ${i + 1}`}
                  className="img-fluid rounded"
                  height="120"
                  src={image.url}
                  style={{
                    width: "120px",
                    height: "120px",
                    aspectRatio: "120/120",
                    objectFit: "cover",
                    cursor: "pointer",
                  }}
                  width="120"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="col-md-5">
          <h1 className="h3 mb-3">{product.name}</h1>
          <div className="d-flex align-items-center mb-3">
            <div className="d-flex">
              {[...Array(5)].map((_, i) => (
                <BsStarFill key={i} className="text-warning me-1" />
              ))}
            </div>
            <span className="ms-2 text-primary">1234 évaluations</span>
          </div>
          <div className="border-top border-bottom py-3 mb-3">
            <span className="h4 fw-bold">
              {parseFloat(product.price).toFixed(2)} $
            </span>
            <p className="text-success mt-2">En stock.</p>
          </div>
          <p className="mb-4">{product.description}</p>

          {/* Quantity */}
          <div className="quantity-counter mb-3">
            <div className="js-quantity-counter row align-items-center ">
              <div className="col">
                <span className="d-block small">Select quantity</span>
                <input
                  className="js-result form-control form-control-quantity-counter "
                  type="text"
                  value={quantity}
                  readOnly
                />
              </div>
              <div className="col-auto">
                <button
                  className="js-minus btn btn-outline-secondary btn-xs btn-icon rounded-circle"
                  onClick={decreaseQuantity}
                >
                  -
                </button>
                <button
                  className="js-plus btn btn-outline-secondary btn-xs btn-icon rounded-circle"
                  onClick={increaseQuantity}
                >
                  +
                </button>
              </div>
            </div>
          </div>

          {/* Add to Cart Button */}

          <button
            type="button"
            className="btn btn-primary btn-transition mb-2 w-100"
            onClick={handleAddToCart}
          >
            <FaShoppingCart className="me-2" /> Add to cart
          </button>
          <button className="btn btn-outline-secondary btn-transition w-100">
            <FaHeart className="me-2" /> Add to whislist
          </button>
          <div className="d-flex justify-content-between align-items-center pt-4 border-top mt-4">
            <button className="btn btn-link text-secondary">
              <FaShareAlt className="me-2" /> Partager
            </button>
            <span className="text-muted">Réf. : ABC123</span>
          </div>
        </div>
      </div>
      {/* </div> */}
    </main>
  );
};

export default ProductDetail;
